module.exports = __webpack_public_path__ + "300e03de57a3fd6af54bc6590c8542bd.png";